import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { Accordion } from './components/Accordion';
import { BonusCard } from './components/BonusCard';
import { TestimonialCard } from './components/TestimonialCard';
import { ClipboardListIcon, CheckCircleIcon, ShieldCheckIcon, DownloadIcon, ClockIcon } from 'lucide-react';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      ;
      (window as any).fbq?.('track', 'PageView');
    }
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <PurchaseNotification data-id="element-2" />

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-green-50 to-gray-50 py-12 md:py-20" data-id="element-3">
        <div className="max-w-6xl mx-auto px-4" data-id="element-4">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-center text-gray-900 display-font leading-tight mb-8" data-id="element-5">
            Si sos profe de baby fútbol, esto te puede ahorrar horas de estrés.
          </h1>

          <div className="max-w-4xl mx-auto mb-8" data-id="element-6">
            <img src="https://cdn.magicpatterns.com/uploads/rJdekPxveya5VXr6VheYkK/ChatGPT_Image_May_24__2026__11_23_21_PM-removebg-preview-removebg-preview.png" alt="Baby Fútbol Resuelto" className="w-full rounded-2xl shadow-xl cursor-pointer hover:scale-[1.02] transition-transform" onClick={scrollToPurchase} data-id="element-7" />
          </div>

          <p className="text-xl md:text-2xl text-center text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-8">
            Un sistema diseñado para profes que aman enseñar, pero están
            cansados de improvisar.
          </p>

          <div className="flex justify-center" data-id="element-9">
            <button onClick={scrollToPurchase} className="bg-green-800 hover:bg-green-900 text-white px-8 py-4 rounded-full text-lg md:text-xl font-bold shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-10">
              ⚽ QUIERO DEJAR DE IMPROVISAR MIS CLASES
            </button>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 bg-gray-50" data-id="element-11">
        <div className="max-w-4xl mx-auto px-4" data-id="element-12">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10 border border-gray-200 border-l-4 border-l-red-600" data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 display-font" data-id="element-14">
              Terminás una clase<span className="text-red-600" data-id="element-15">…</span>
            </h2>
            <p className="text-xl text-gray-700 mb-6" data-id="element-16">
              Y cuando llegás a tu casa,{' '}
              <span className="text-red-600 font-semibold" data-id="element-17">
                la cabeza sigue trabajando.
              </span>
            </p>
            <p className="text-lg text-gray-600 mb-4 font-semibold" data-id="element-18">
              Pensando:
            </p>
            <ul className="space-y-3 text-lg text-gray-700" data-id="element-19">
              <li className="flex items-start gap-3" data-id="element-20">
                <span className="text-red-600 font-bold text-xl leading-none" data-id="element-21">
                  ✗
                </span>
                <span data-id="element-22">Qué ejercicios hacer</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-23">
                <span className="text-red-600 font-bold text-xl leading-none" data-id="element-24">
                  ✗
                </span>
                <span data-id="element-25">Cómo organizar el grupo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-26">
                <span className="text-red-600 font-bold text-xl leading-none" data-id="element-27">
                  ✗
                </span>
                <span data-id="element-28">Cómo evitar que los chicos se aburran</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-29">
                <span className="text-red-600 font-bold text-xl leading-none" data-id="element-30">
                  ✗
                </span>
                <span data-id="element-31">Cómo hacer que la clase no se desordene</span>
              </li>
            </ul>
            <p className="text-xl text-red-600 mt-6 font-bold" data-id="element-32">
              Y así pasan semanas improvisando todo.
            </p>
          </div>
        </div>
      </section>

      {/* Real Problem Section - Compact */}
      <section className="py-12 bg-gray-50" data-id="element-33">
        <div className="max-w-4xl mx-auto px-4" data-id="element-34">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10 border border-gray-200" data-id="element-35">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 display-font" data-id="element-36">
              🚨 El problema NO es falta de ejercicios
            </h2>
            <p className="text-base md:text-lg text-gray-700 mb-4" data-id="element-37">
              Hoy hay miles de videos y reels gratis. Pero:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-38">
              <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg" data-id="element-39">
                <span className="text-red-500 font-bold" data-id="element-40">❌</span>
                <span className="text-gray-700" data-id="element-41">No tienen estructura</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg" data-id="element-42">
                <span className="text-red-500 font-bold" data-id="element-43">❌</span>
                <span className="text-gray-700" data-id="element-44">No tienen progresión</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg" data-id="element-45">
                <span className="text-red-500 font-bold" data-id="element-46">❌</span>
                <span className="text-gray-700" data-id="element-47">
                  No sirven para clases reales
                </span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg" data-id="element-48">
                <span className="text-red-500 font-bold" data-id="element-49">❌</span>
                <span className="text-gray-700" data-id="element-50">
                  No resuelven el caos de una escuelita
                </span>
              </div>
            </div>
            <p className="text-lg text-gray-700" data-id="element-51">
              El verdadero problema es otro:{' '}
              <span className="font-bold text-emerald-500" data-id="element-52">
                👉 No tenés un sistema.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Product Presentation */}
      <section className="py-16 bg-gradient-to-b from-green-50 to-gray-50" data-id="element-53">
        <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-54">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 border border-gray-200" data-id="element-55">
            <p className="text-lg md:text-xl text-gray-600 mb-2 font-semibold uppercase tracking-wide" data-id="element-56">
              Presentamos
            </p>
            <h2 className="text-5xl md:text-7xl font-bold mb-6 display-font text-emerald-500" data-id="element-57">
              BABY FÚTBOL RESUELTO
            </h2>
            <p className="text-xl md:text-2xl text-gray-700 font-semibold" data-id="element-58">
              📘 El sistema completo para profes de fútbol infantil y educación
              física
            </p>
          </div>
        </div>
      </section>

      {/* 6 Capítulos Section */}
      <section className="py-16 bg-gray-50" data-id="element-59">
        <div className="max-w-5xl mx-auto px-4" data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-4 display-font" data-id="element-61">
            📚 ¿Qué incluye?
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-center text-emerald-500 mb-12 display-font" data-id="element-62">
            ✅ 6 CAPÍTULOS COMPLETOS
          </h3>

          <div className="space-y-4" data-id="element-63">
            <Accordion title="CAPÍTULO 1 — Cómo enseñar fútbol infantil desde cero" subtitle="Bases reales para formar jugadores infantiles sin improvisar — 45–60 páginas" data-id="element-64">
              <div className="space-y-6" data-id="element-65">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-66">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-67">
                    Capítulo 1: Qué necesita aprender un niño primero
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-68">
                    <li data-id="element-69">🧠 Etapas del aprendizaje infantil</li>
                    <li data-id="element-70">⚽ Prioridades reales según edad</li>
                    <li data-id="element-71">🚫 Errores típicos de profes principiantes</li>
                    <li data-id="element-72">🎯 Cómo generar confianza desde la primera clase</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-73">
                      Visuales: Línea evolutiva por edades, Comparativa "error
                      vs correcto", Pirámide de aprendizaje
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-74">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-75">
                    Capítulo 2: Cómo dividir grupos por edades y niveles
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-76">
                    <li data-id="element-77">👦 4–6 años, 7–9 años, 10–12 años, 13–15 años</li>
                    <li data-id="element-78">📋 Cómo adaptar ejercicios según nivel</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-79">
                      Visuales: Tablas comparativas, Ejemplo de grupos, Fichas
                      de niveles
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-80">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-81">
                    Capítulo 3: Cómo organizar grupos numerosos
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-82">
                    <li data-id="element-83">🧩 Rotaciones inteligentes</li>
                    <li data-id="element-84">⏱️ Cómo evitar tiempos muertos</li>
                    <li data-id="element-85">⚽ Estaciones dinámicas</li>
                    <li data-id="element-86">🚨 Cómo mantener atención</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-87">
                      Visuales: Armado de estaciones, Organización de conos,
                      Diagramas de flujo
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-88">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-89">
                    Capítulo 4: Entrada en calor con pelota
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-90">
                    <li data-id="element-91">🔥 Activaciones divertidas</li>
                    <li data-id="element-92">⚽ Coordinación inicial</li>
                    <li data-id="element-93">🏃 Movilidad con pelota</li>
                    <li data-id="element-94">🎯 Juegos de reacción</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-95">
                      Visuales: Circuitos, Juegos rápidos, Secuencias ilustradas
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-96">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-97">
                    Capítulo 5: Dominio básico
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-98">
                    <li data-id="element-99">👣 Conducción inicial</li>
                    <li data-id="element-100">🔄 Cambios de dirección</li>
                    <li data-id="element-101">⚽ Familiarización con pelota</li>
                    <li data-id="element-102">🎮 Juegos técnicos básicos</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-103">
                      Visuales: Recorridos, Conos y trayectorias, Correcciones
                      técnicas
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-104">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-105">
                    Capítulo 6: Pase y recepción inicial
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-106">
                    <li data-id="element-107">🎯 Pase corto</li>
                    <li data-id="element-108">🦶 Perfil corporal</li>
                    <li data-id="element-109">👀 Recepción orientada</li>
                    <li data-id="element-110">🤝 Trabajo en parejas</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-111">
                      Visuales: Posición corporal, Ángulo de pase, Errores
                      frecuentes
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-112">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-113">
                    Capítulo 7: Juegos para perder el miedo
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-114">
                    <li data-id="element-115">😅 Niños tímidos</li>
                    <li data-id="element-116">⚽ Juegos recreativos</li>
                    <li data-id="element-117">🧠 Integración grupal</li>
                    <li data-id="element-118">🎉 Dinámicas competitivas sanas</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-119">
                      Visuales: Juegos ilustrados, Desafíos, Mini competencias
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-120">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-121">
                    Capítulo 8: Cómo evitar filas eternas
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-122">
                    <li data-id="element-123">🚫 El problema número 1 de las escuelitas</li>
                    <li data-id="element-124">⚡ Cómo maximizar contacto con pelota</li>
                    <li data-id="element-125">🔄 Ejercicios simultáneos</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-126">
                      Visuales: "Mal armado vs bien armado", Organización
                      eficiente
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-127">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-128">
                    Capítulo 9: Correcciones simples y efectivas
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-129">
                    <li data-id="element-130">🧠 Cómo corregir sin frustrar</li>
                    <li data-id="element-131">📢 Qué decir y qué NO decir</li>
                    <li data-id="element-132">🎯 Correcciones rápidas</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-133">
                      Visuales: Ejemplos prácticos, Lenguaje positivo
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg" data-id="element-134">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-135">
                    Capítulo 10: Clase modelo inicial
                  </h4>
                  <ul className="text-sm text-gray-700 space-y-1 ml-4" data-id="element-136">
                    <li data-id="element-137">📝 Clase completa lista</li>
                    <li data-id="element-138">⏱️ Tiempos</li>
                    <li data-id="element-139">⚽ Ejercicios</li>
                    <li data-id="element-140">🎯 Objetivos</li>
                    <li className="text-xs text-gray-500 mt-2" data-id="element-141">
                      Visuales: Clase completa ilustrada
                    </li>
                  </ul>
                </div>
              </div>
            </Accordion>

            <Accordion title="CAPÍTULO 2 — Técnica base: pase, control, conducción y definición" subtitle="Cómo desarrollar jugadores técnicamente sólidos — 45–60 páginas" data-id="element-142">
              <div className="space-y-4" data-id="element-143">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-144">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-145">
                    Cap 1: Control orientado
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-146">
                    👀 Perfil corporal, ⚽ Primer toque, 🔄 Orientación del
                    cuerpo. Diagramas técnicos
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-147">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-148">
                    Cap 2: Pase corto
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-149">
                    🎯 Técnica correcta, 🦶 Superficie de contacto, 🤝
                    Precisión. Correcciones visuales
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-150">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-151">
                    Cap 3: Pase largo infantil
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-152">
                    🚀 Técnica adaptada, ⚡ Fuerza progresiva, 🎯
                    Direccionalidad. Trayectorias ilustradas
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-153">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-154">
                    Cap 4: Conducción con ambos pies
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-155">
                    👣 Dominio bilateral, 🔄 Cambios de ritmo, 🧠 Coordinación.
                    Circuitos técnicos
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-156">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-157">
                    Cap 5: Definición simple
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-158">
                    🥅 Finalización básica, 🎯 Precisión antes que fuerza, ⚽
                    Remate en movimiento. Posición corporal
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-159">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-160">
                    Cap 6: Tiros al arco en juego
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-161">
                    🏃 Finalización real, ⚡ Velocidad de decisión, 🎮 Juegos de
                    definición. Secuencias ilustradas
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-162">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-163">
                    Cap 7: Circuitos técnicos
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-164">
                    🔄 Rotaciones, ⚽ Multitareas, 🧩 Estaciones. Armado
                    completo
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-165">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-166">
                    Cap 8: Estaciones por nivel
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-167">
                    🟢 Principiante, 🟡 Intermedio, 🔴 Avanzado. Organización
                    visual
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-168">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-169">
                    Cap 9: Correcciones técnicas frecuentes
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-170">
                    🚫 Pase incorrecto, 🚫 Mal control, 🚫 Cabeza baja. "Error
                    vs correcto"
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-171">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-172">
                    Cap 10: Clase técnica completa
                  </h4>
                  <p className="text-sm text-gray-700" data-id="element-173">
                    📝 Clase lista, ⚽ Ejercicios, 🎯 Objetivos. Clase ilustrada
                  </p>
                </div>
              </div>
            </Accordion>

            <Accordion title="CAPÍTULO 3 — Juegos reducidos y toma de decisiones" subtitle="Cómo enseñar a pensar el juego — 45–60 páginas" data-id="element-174">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-175">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-176">
                  <p className="font-bold text-gray-900" data-id="element-177">⚔️ 1 vs 1 ofensivo</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-178">
                  <p className="font-bold text-gray-900" data-id="element-179">🛡️ 1 vs 1 defensivo</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-180">
                  <p className="font-bold text-gray-900" data-id="element-181">⚡ 2 vs 1</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-182">
                  <p className="font-bold text-gray-900" data-id="element-183">🔄 3 vs 2</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-184">
                  <p className="font-bold text-gray-900" data-id="element-185">🎯 Cuándo pasar</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-186">
                  <p className="font-bold text-gray-900" data-id="element-187">🚀 Cuándo encarar</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-188">
                  <p className="font-bold text-gray-900" data-id="element-189">
                    👀 Cómo levantar la cabeza
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-190">
                  <p className="font-bold text-gray-900" data-id="element-191">
                    🏟️ Mini partidos condicionados
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-192">
                  <p className="font-bold text-gray-900" data-id="element-193">
                    🧩 Juegos con comodines
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-194">
                  <p className="font-bold text-gray-900" data-id="element-195">
                    📋 Clase táctica completa
                  </p>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-4" data-id="element-196">
                Visuales: Diagramas tácticos, Flechas de movimiento, Secuencias
                de decisión, Mini canchas ilustradas
              </p>
            </Accordion>

            <Accordion title="CAPÍTULO 4 — Defensa, presión y orden" subtitle="Cómo formar jugadores inteligentes sin desorden — 45–60 páginas" data-id="element-197">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-198">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-199">
                  <p className="font-bold text-gray-900" data-id="element-200">
                    Posición defensiva básica
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-201">
                  <p className="font-bold text-gray-900" data-id="element-202">
                    Cómo enseñar a marcar
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-203">
                  <p className="font-bold text-gray-900" data-id="element-204">
                    Cerrar líneas de pase
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-205">
                  <p className="font-bold text-gray-900" data-id="element-206">Recuperar sin pegar</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-207">
                  <p className="font-bold text-gray-900" data-id="element-208">
                    Presión tras pérdida
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-209">
                  <p className="font-bold text-gray-900" data-id="element-210">
                    Defensa grupal infantil
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-211">
                  <p className="font-bold text-gray-900" data-id="element-212">
                    Orden en cancha reducida
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-213">
                  <p className="font-bold text-gray-900" data-id="element-214">Juegos defensivos</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-215">
                  <p className="font-bold text-gray-900" data-id="element-216">
                    Correcciones frecuentes
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-217">
                  <p className="font-bold text-gray-900" data-id="element-218">
                    Clase defensiva lista
                  </p>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-4" data-id="element-219">
                Visuales: Coberturas defensivas, Presión ilustrada,
                Recuperaciones, Organización defensiva
              </p>
            </Accordion>

            <Accordion title="CAPÍTULO 5 — Preparación física infantil con pelota" subtitle="Desarrollo físico seguro y divertido — 45–60 páginas" data-id="element-220">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-221">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-222">
                  <p className="font-bold text-gray-900" data-id="element-223">
                    Coordinación general
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-224">
                  <p className="font-bold text-gray-900" data-id="element-225">Velocidad inicial</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-226">
                  <p className="font-bold text-gray-900" data-id="element-227">Reacción</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-228">
                  <p className="font-bold text-gray-900" data-id="element-229">
                    Cambios de dirección
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-230">
                  <p className="font-bold text-gray-900" data-id="element-231">Equilibrio</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-232">
                  <p className="font-bold text-gray-900" data-id="element-233">Saltos seguros</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-234">
                  <p className="font-bold text-gray-900" data-id="element-235">Fuerza lúdica</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-236">
                  <p className="font-bold text-gray-900" data-id="element-237">
                    Prevención de lesiones
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-238">
                  <p className="font-bold text-gray-900" data-id="element-239">
                    Juegos físicos con pelota
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-240">
                  <p className="font-bold text-gray-900" data-id="element-241">
                    Clase física integrada
                  </p>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-4" data-id="element-242">
                Visuales: Circuitos físicos, Escaleras de coordinación, Saltos,
                Juegos dinámicos
              </p>
            </Accordion>

            <Accordion title="CAPÍTULO 6 — Planificación completa para escuelitas de fútbol" subtitle="El sistema que evita improvisar cada semana — 45–60 páginas" data-id="element-243">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-244">
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-245">
                  <p className="font-bold text-gray-900" data-id="element-246">📅 Plan mensual</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-247">
                  <p className="font-bold text-gray-900" data-id="element-248">📆 Plan trimestral</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-249">
                  <p className="font-bold text-gray-900" data-id="element-250">🗓️ Plan anual</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-251">
                  <p className="font-bold text-gray-900" data-id="element-252">
                    📊 Cómo evaluar jugadores
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-253">
                  <p className="font-bold text-gray-900" data-id="element-254">
                    🧩 Cómo armar grupos por nivel
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-255">
                  <p className="font-bold text-gray-900" data-id="element-256">
                    👨‍👩‍👦 Cómo hablar con padres
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-257">
                  <p className="font-bold text-gray-900" data-id="element-258">🏆 Torneos internos</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-259">
                  <p className="font-bold text-gray-900" data-id="element-260">
                    🏟️ Clases para poco espacio
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-261">
                  <p className="font-bold text-gray-900" data-id="element-262">
                    ⚽ Clases con pocos materiales
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-263">
                  <p className="font-bold text-gray-900" data-id="element-264">
                    💻 Sistema completo editable
                  </p>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-4" data-id="element-265">
                Visuales: Calendarios, Planillas, Seguimiento visual,
                Evaluaciones
              </p>
            </Accordion>
          </div>
        </div>
      </section>

      {/* Bonos Section */}
      <section className="py-16 bg-gray-50" data-id="element-266">
        <div className="max-w-6xl mx-auto px-4" data-id="element-267">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-4 display-font" data-id="element-268">
            🎁 BONOS EXCLUSIVOS
          </h2>
          <div className="text-center mb-12" data-id="element-269">
            <span className="inline-block bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-3 rounded-full text-xl md:text-2xl font-bold shadow-lg" data-id="element-270">
              GRATIS POR EL DÍA DE HOY
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-271">
            <BonusCard title="40 juegos con pelota" description="Ejercicios dinámicos para mantener a todos activos durante toda la clase." imageUrl="https://cdn.magicpatterns.com/uploads/aTa8PWNKcr9GCFa6Hbj7hL/Captura_de_pantalla_2026-05-24_225615.png" data-id="element-272" />

            <BonusCard title="25 clases listas para fútbol infantil" description="Abrís el sistema y aplicás. Clases completas con estructura, tiempos y objetivos." imageUrl="https://cdn.magicpatterns.com/uploads/6CMqFT2Eh7QFn6GazEqXkW/Captura_de_pantalla_2026-05-24_225636.png" data-id="element-273" />

            <BonusCard title="Planillas Editables" description="Planillas para: Planificación / Seguimiento / Objetivos / Evaluaciones / Asistencia." icon={<ClipboardListIcon className="w-24 h-24" data-id="element-275" />} data-id="element-274" />

            <BonusCard title="Sistema de resolución de clases — grupos complicados" description="Qué hacer cuando la clase se desordena. Protocolos paso a paso para retomar el control." imageUrl="https://cdn.magicpatterns.com/uploads/fcH3VzX4qVRN3Ah4W7bbUZ/Captura_de_pantalla_2026-05-24_225523.png" data-id="element-276" />
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50" data-id="element-277">
        <div className="max-w-6xl mx-auto px-4" data-id="element-278">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12 display-font" data-id="element-279">
            ⭐ Lo que dicen los profes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-280">
            <TestimonialCard name="Martín Quiroga" age={34} role="Profe de Educación Física" location="Rosario, Santa Fe" text="Tenía la cabeza explotada armando clases cada semana. Con este sistema dejé de improvisar y los chicos lo notan. Aprenden más y se divierten más." data-id="element-281" />

            <TestimonialCard name="Lucía Fernández" age={29} role="Coordinadora de escuelita" location="La Plata, Buenos Aires" text="Las planillas editables me cambiaron la vida. Tengo todo organizado y los padres ven el progreso de los chicos." data-id="element-282" />

            <TestimonialCard name="Diego Romero" age={42} role="DT de baby fútbol" location="Córdoba Capital" text="Lo que más me sirvió fue el sistema anti-caos. Antes terminaba agotado, ahora la clase fluye sola." data-id="element-283" />

            <TestimonialCard name="Pablo Giménez" age={38} role="Profe de fútbol infantil" location="Mendoza" text="Los juegos reducidos del Capítulo 3 son oro. Los chicos piensan más rápido y juegan mejor en los partidos." data-id="element-284" />

            <TestimonialCard name="Carolina Sosa" age={31} role="Profe en club barrial" location="Mar del Plata, Buenos Aires" text="Yo arrancaba sin experiencia y este material me dio la estructura que me faltaba. Súper recomendado." data-id="element-285" />
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="compra" className="py-16 bg-gradient-to-b from-green-50 to-gray-50" data-id="element-286">
        <div className="max-w-4xl mx-auto px-4" data-id="element-287">
          <div className="bg-white rounded-2xl shadow-md p-8 md:p-12 border-2 border-emerald-500" data-id="element-288">
            <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-4 display-font" data-id="element-289">
              🚨 OFERTA POR TIEMPO LIMITADO
            </h2>

            <p className="text-lg md:text-xl text-center text-gray-700 mb-8 font-semibold" data-id="element-290">
              Hoy te llevás todo + 4 BONOS GRATIS
            </p>

            <div className="bg-emerald-50 rounded-xl p-8 mb-8 border border-emerald-200" data-id="element-291">
              <div className="text-center mb-6" data-id="element-292">
                <p className="text-gray-500 line-through text-2xl mb-2" data-id="element-293">
                  $52.690
                </p>
                <div className="bg-emerald-700 text-white inline-block px-8 py-4 rounded-xl shadow-md" data-id="element-294">
                  <p className="text-5xl md:text-6xl font-bold display-font" data-id="element-295">
                    $19.899
                  </p>
                </div>
                <p className="text-lg text-gray-600 mt-4 font-semibold" data-id="element-296">
                  Pago único — Acceso inmediato
                </p>
              </div>

              <a href="https://checkout.ebookpoint.shop/cart/59560688910417:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-md mx-auto bg-emerald-800 hover:bg-emerald-900 text-white text-center px-6 py-3 rounded-full text-base md:text-lg font-bold shadow-md hover:shadow-lg transition-all transform hover:scale-105" data-id="element-297">
                ⚽ QUIERO DEJAR DE IMPROVISAR MIS CLASES
              </a>

              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-3 text-center text-sm text-gray-700" data-id="element-298">
                <div className="flex items-center justify-center gap-2" data-id="element-299">
                  <ShieldCheckIcon className="w-5 h-5 text-emerald-500" data-id="element-300" />
                  <span data-id="element-301">Pago 100% seguro</span>
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-302">
                  <DownloadIcon className="w-5 h-5 text-emerald-500" data-id="element-303" />
                  <span data-id="element-304">Acceso inmediato</span>
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-305">
                  <CheckCircleIcon className="w-5 h-5 text-emerald-500" data-id="element-306" />
                  <span data-id="element-307">Todos los bonos incluidos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ / Objections Section */}
      <section className="py-16 bg-gray-50" data-id="element-308">
        <div className="max-w-4xl mx-auto px-4" data-id="element-309">
          <p className="text-center text-xl md:text-2xl text-gray-700 italic font-medium mb-10 max-w-2xl mx-auto" data-id="element-310">
            "El problema no es enseñar fútbol. Es improvisar todos los días."
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-4 display-font" data-id="element-311">
            ❓ Preguntas frecuentes
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-312">
            Resolvemos las dudas más comunes antes de tu compra
          </p>

          <div className="space-y-4" data-id="element-313">
            <Accordion title="¿Sirve si recién arranco como profe y no tengo experiencia?" subtitle="Ideal para profes principiantes" data-id="element-314">
              <p className="text-gray-700 leading-relaxed" data-id="element-315">
                Sí, totalmente. El sistema está pensado desde cero. Empieza con
                las bases del Capítulo 1 (cómo dividir grupos, cómo dar la
                primera clase, cómo evitar errores típicos) y avanza
                gradualmente. Vas a tener clases modelo, correcciones explicadas
                paso a paso y todo el material listo para usar desde el primer
                día.
              </p>
            </Accordion>

            <Accordion title="¿Y si ya tengo años dando clases? ¿Me sirve igual?" subtitle="Pensado también para profes con experiencia" data-id="element-316">
              <p className="text-gray-700 leading-relaxed" data-id="element-317">
                Por supuesto. Los profes con experiencia valoran sobre todo las
                planillas editables, el sistema anti-caos para grupos
                complicados y la planificación anual ya armada. Vas a ahorrar
                horas cada semana en preparar clases y vas a tener nuevas ideas,
                juegos reducidos y formatos de torneo que probablemente no estás
                usando.
              </p>
            </Accordion>

            <Accordion title="¿Cómo recibo el material después de comprar?" subtitle="Acceso inmediato — 100% digital" data-id="element-318">
              <p className="text-gray-700 leading-relaxed" data-id="element-319">
                Apenas terminás el pago, recibís un email con el acceso completo
                a los 6 capítulos y los 4 bonos. Podés descargarlo en tu
                computadora, celular o tablet. El acceso es de por vida, sin
                suscripciones ni pagos recurrentes.
              </p>
            </Accordion>

            <Accordion title="¿Funciona para todas las edades?" subtitle="De 4 a 15 años" data-id="element-320">
              <p className="text-gray-700 leading-relaxed" data-id="element-321">
                Sí. El sistema está dividido por edades: 4-6, 7-9, 10-12 y 13-15
                años. Cada ejercicio y clase está adaptado a la etapa cognitiva
                y física de los chicos. Vas a saber exactamente qué hacer con
                cada grupo.
              </p>
            </Accordion>

            <Accordion title="No tengo mucho espacio ni materiales. ¿Igual me sirve?" subtitle="Adaptable a cualquier realidad" data-id="element-322">
              <p className="text-gray-700 leading-relaxed" data-id="element-323">
                Sí. Hay un módulo específico para clases en poco espacio
                (pasillos, SUM, media cancha) y otro para clases con pocos
                materiales (sin conos, sin arcos, con recursos alternativos). El
                sistema está pensado para la realidad de las escuelitas
                argentinas.
              </p>
            </Accordion>

            <Accordion title="¿Es un pago único o tengo que pagar mensualmente?" subtitle="Un solo pago, acceso de por vida" data-id="element-324">
              <p className="text-gray-700 leading-relaxed" data-id="element-325">
                Es un pago único de $19.899. No hay suscripciones ni cobros
                adicionales. Pagás una vez y tenés acceso para siempre,
                incluidas las futuras actualizaciones del material.
              </p>
            </Accordion>

            <Accordion title="¿Puedo usarlo en mi escuelita, club o como profe particular?" subtitle="Sin restricciones de uso" data-id="element-326">
              <p className="text-gray-700 leading-relaxed" data-id="element-327">
                Sí, podés usarlo en cualquier contexto: escuelitas barriales,
                clubes, colegios, clases particulares o entrenamientos
                personales. El material es tuyo y lo aplicás donde quieras.
              </p>
            </Accordion>

            <Accordion title="¿Y si después de comprarlo no me convence?" subtitle="Garantía de satisfacción" data-id="element-328">
              <p className="text-gray-700 leading-relaxed" data-id="element-329">
                Tenés 7 días para revisar todo el material. Si no te sirve por
                cualquier motivo, te devolvemos el 100% de tu dinero. Sin
                preguntas, sin vueltas. El riesgo es cero.
              </p>
            </Accordion>

            <Accordion title="¿Las planillas son realmente editables?" subtitle="100% editables en cualquier dispositivo" data-id="element-330">
              <p className="text-gray-700 leading-relaxed" data-id="element-331">
                Sí. Las planillas vienen en formato editable para que las
                completes en tu compu, celular o las imprimas. Incluyen
                asistencia, evaluaciones técnicas, seguimiento individual,
                objetivos mensuales y planificación semanal.
              </p>
            </Accordion>

            <Accordion title="¿Por qué este precio es tan bajo?" subtitle="Oferta de lanzamiento por tiempo limitado" data-id="element-332">
              <p className="text-gray-700 leading-relaxed" data-id="element-333">
                El precio normal es $52.690. La oferta actual de $19.899 es por
                tiempo limitado para que más profes puedan acceder al sistema.
                Una vez que termine el descuento, el precio vuelve a su valor
                normal.
              </p>
            </Accordion>
          </div>

          <div className="mt-12 text-center" data-id="element-334">
            <button onClick={scrollToPurchase} className="bg-emerald-800 hover:bg-emerald-900 text-white px-8 py-4 rounded-full text-lg md:text-xl font-bold shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-335">
              ⚽ QUIERO DEJAR DE IMPROVISAR MIS CLASES
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8" data-id="element-336">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-337">
          <p className="text-lg font-bold text-emerald-500 mb-2 display-font" data-id="element-338">
            Baby Fútbol Resuelto
          </p>
          <p className="text-sm text-gray-500" data-id="element-339">
            El sistema completo para profes de fútbol infantil
          </p>
        </div>
      </footer>

      {/* Meta Pixel Script */}
      <script dangerouslySetInnerHTML={{
      __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1252242806993118');
          fbq('track', 'PageView');
        `
    }} data-id="element-340" />
    </div>;
}